import React from 'react';
import styled from 'styled-components';

import { Spin as AntSpin } from 'antd';

const Spin = styled(AntSpin)`
  && {
    .ant-spin-dot {
      i {
        background-color: ${({ theme }) => theme.colors.text.primary};
      }
    }
  }
`;

const Container = styled.div`
  background: rgba(0, 0, 0, 0.4);
  z-index: 1054;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > div {
    position: fixed;
    top: 50%;
    left: 50%;
  }
`;

type Props = {
  active: boolean;
};

const Loader = ({ active }: Props) =>
  active ? (
    <Container>
      <Spin spinning={active} size="large" />
    </Container>
  ) : (
    <div />
  );

export default Loader;
